import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ManualFileUploadForm } from '../forms'
import { selectors as globalSelectors } from '../../reducer'
import * as Types from 'types'
import { flashErrorMessage, flashSuccessMessage } from 'redux-flash'
import {
  TOAST_ERROR_CONTACT_SUPPORT,
  MANUAL_FILE_UPLOAD_SUCCESS_MODAL,
} from 'config/notifications'
import * as apiActions from 'api-actions'
import { FLASH_SUCCESS_WITH_USER_ACTION_TIMEOUT } from 'config/portal'

const propTypes = {
  currentUser: Types.user.isRequired,
  flashSuccessMessageHandler: PropTypes.func.isRequired,
  flashErrorMessageHandler: PropTypes.func.isRequired,
  submitManualFileUpload: PropTypes.func.isRequired,
}
const defaultProps = {}

function ManualFileUploadView({
  currentUser,
  flashSuccessMessageHandler,
  flashErrorMessageHandler,
  submitManualFileUpload,
}) {
  const history = useHistory()

  const handleSubmit = async (values) => {
    const formData = new FormData()
    const participantData = {
      accountId: currentUser.accountID,
      contactId: currentUser.contactID,
      reason: values.reason,
      fileDescription: values.description,
      relatedServices: values.relatedServices,
    }
    const originalFile = values.uploadedFile
    const submitFile = new File([originalFile], originalFile.name, {
      type: 'application/octet-stream',
    })
    formData.append('submitData', JSON.stringify(participantData))
    formData.append('submitFile', submitFile)
    try {
      await submitManualFileUpload({
        formData,
      })
    } catch (e) {
      flashErrorMessageHandler(TOAST_ERROR_CONTACT_SUPPORT)
    }
    history.push({
      pathname: '/home',
      state: {
        search: history.location.state?.search,
        ignorePrompt: true,
      },
    })
    flashSuccessMessageHandler(MANUAL_FILE_UPLOAD_SUCCESS_MODAL, {
      timeout: FLASH_SUCCESS_WITH_USER_ACTION_TIMEOUT,
    })
  }

  return (
    <div className="card full-height manual-file-upload-view">
      <div className="form-masthead">
        <h2>Upload a custom file</h2>
        <p>
          If you're working with your relationship manager on a special use
          case, use this page to upload your participant file.
        </p>
      </div>
      <div className="form-section">
        <ManualFileUploadForm
          handleSubmit={handleSubmit}
          initialValues={{
            uploadedFile: '',
            description: '',
            relatedServices: [],
            reason: '',
          }}
        />
      </div>
    </div>
  )
}

ManualFileUploadView.propTypes = propTypes
ManualFileUploadView.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    currentUser: globalSelectors.currentUser(state),
  }
}

const mapDispatchToProps = {
  flashSuccessMessageHandler: flashSuccessMessage,
  flashErrorMessageHandler: flashErrorMessage,
  submitManualFileUpload: apiActions.submitManualFileUpload,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ManualFileUploadView)
)
